import React from "react"
import { Container, Row, Col } from "reactstrap"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
          <Col md={6}>{new Date().getFullYear()} © Gruppo Bisaro.</Col>
            <Col md={6}>
              <div className="text-sm-end d-none d-sm-block">
                Progettato & Sviluppato da <a className="colorHeytech" target="_blank" rel="noreferrer" href="https://www.heytech.it">Heytech</a>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
